import * as React from 'react';

export const LAPillar = (props: React.SVGProps<SVGPathElement>) => (
	<path id="LAPILLAR" stroke="#000" d="M168 202.5l14.5 45-5 1.5-8.5-26.5-1-20z" {...props} />
);
